import React from 'react'
import { EMBED_PARTNERS, EMBED_PRODUCTS } from 'parameters'
import MultiProductWidget from 'components/vendor/MultiProductWidget/MultiProductWidget'
import ProductPageLayout from 'experiences/products/common/ProductPageLayout'
import { ExplorePageProps } from 'types/page'
import { useContentfulResourcesMapped } from 'stores/Contentful/hooks'
import { ResourceUtils } from 'services/ContentfulService/models/resource/utils'

export const CreditCards = ({ articles, isCnfEmbedExperience }: ExplorePageProps): JSX.Element => {
	const pageResources = useContentfulResourcesMapped()

	return (
		<ProductPageLayout
			product={EMBED_PRODUCTS.CREDIT_CARD}
			isCnfEmbedExperience={isCnfEmbedExperience}
			articles={articles}
			title={
				<h1>
					{ResourceUtils(pageResources['credit_cards.title_1']).getPlainTextContent()}{' '}
					<strong>{ResourceUtils(pageResources['credit_cards.title_2']).getPlainTextContent()}</strong>
				</h1>
			}
			description={ResourceUtils(pageResources['credit_cards.description']).getPlainTextContent()}
		>
			<MultiProductWidget
				product={EMBED_PRODUCTS.CREDIT_CARD}
				partner={EMBED_PARTNERS.FIONA_CC}
				isCnfEmbedExperience={isCnfEmbedExperience}
			/>
		</ProductPageLayout>
	)
}
